// extracted by mini-css-extract-plugin
export default {"ul":"LanguageSwitcher_ul__PVOhw","languageLi":"LanguageSwitcher_languageLi__1k6-U","label":"LanguageSwitcher_label__TckyB","selectedLine":"LanguageSwitcher_selectedLine__KOMik"};